import {
    RESEND_INVITE_OPEN_MODAL,
    RESEND_INVITE_CLOSE_MODAL,
    RESEND_INVITE_REQUEST,
    RESEND_INVITE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    entity: null,
    callback: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case RESEND_INVITE_OPEN_MODAL:
            return { ...state, openModal: true, entity: action.payload.entity, callback: action.payload.callback }

        case RESEND_INVITE_CLOSE_MODAL:
            return { ...state, openModal: false }

        case RESEND_INVITE_REQUEST:
            return { ...state, loading: true }

        case RESEND_INVITE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "RESEND_INVITE"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};